import React from 'react'
import { useSelector } from 'react-redux'
import { ROUTE_ITINERARY_TO } from '../../../routes'
import { navigateTo } from '../../../store/history/history.actions'
import { selectIsItineraryUniverse } from '../../../store/history/history.selectors'
import { setArrivalFromPoint } from '../../../store/itinerary/itinerary.actions'
import { selectLocale } from '../../../store/navigation/navigation.selectors'
import { useT } from '../../i18n/T'
import { useAction } from '../../utils/react-redux'
import ContextMenuItem from './ContextMenuItem'
import { ITINERAIRE_VERS } from './contextmenu.constants'
import { findAddressFromPoint } from './contextmenu.utils'

const ContextMenuItemItineraryTo = () => {
  const label = useT('map.context-menu.go-to-itinerary')
  const execSetArrivalFromPoint = useAction(setArrivalFromPoint)
  const itineraryUniverse = useSelector(selectIsItineraryUniverse)
  const navigateToAction = useAction(navigateTo)
  const locale = useSelector(selectLocale)

  const navigateToItineraryTo = address => {
    navigateToAction({
      route: ROUTE_ITINERARY_TO,
      routeOptions: {
        to: address.label,
        toAddress: address,
        avoidReset: true
      }
    })
  }

  const onItineraryTo = point => {
    if (itineraryUniverse) {
      execSetArrivalFromPoint(point).catch(e => console.error(e))
    } else {
      findAddressFromPoint({ ...point, locale })
        .then(address => navigateToItineraryTo(address))
        .catch(e => console.error(e))
    }
  }

  return <ContextMenuItem tagAction={ITINERAIRE_VERS} label={label} clickAction={onItineraryTo} />
}

export default ContextMenuItemItineraryTo
